const Stack = {
  defaultProps: {
    useFlexGap: true,
  },
  styleOverrides: {},
};

export default Stack;
